import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { Link } from 'react-router-dom';
import PagePlaceholder from '../../components/common/PagePlaceholder';
import PageMeta from '../../components/common/PageMeta';

const Unauthorized = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <PageMeta title={t('errors.unauthorized_title')} robots="noindex, follow" />
      <PagePlaceholder
        tagline={t('errors.unauthorized_tagline')}
        title={t('errors.unauthorized_title')}
        description={t('errors.unauthorized_description')}
      />
      <Box sx={{ textAlign: 'center', pb: 12 }}>
        <Button component={Link} to="/" variant="contained">{t('common.go_home')}</Button>
      </Box>
    </Box>
  );
};

export default Unauthorized;
